//
export default [
    {
        text: "#",
        value: "id",
    },
    {
        text: "nombre",
        value: "role_name",
    },
    /*{
        text: "modulo",
        value: "guard_name",
    },*/
    {
        text: "código",
        value: "name",
    },
    {
        text: "fecha de creación",
        value: "created_at",
        align: "right",
        format: "datetime",
    },
]